import { Spacer, Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import classNames from 'classnames';
import React, { useRef } from 'react';
import styles from './Accordion.module.css';

type AccordionProps = {
  title: string;
  children: React.ReactNode;
  isActive: boolean;
  onToggle: () => void;
};

export const Accordion = ({
  title,
  children,
  isActive,
  onToggle,
}: AccordionProps) => {
  const contentEl = useRef<HTMLDivElement>(null);

  return (
    <div>
      <button type="button" className={styles.toggle} onClick={onToggle}>
        <div className={classNames(styles.icon, { [styles.active]: isActive })}>
          <SystemIcon name="arrow-right" size={16} />
        </div>
        <Spacer right={Spacer.Size.XS} />
        <Text textStyle={Text.Style.HeadingXs}>{title}</Text>
      </button>
      <div
        ref={contentEl}
        className={styles.content}
        style={{ height: isActive ? contentEl.current?.scrollHeight : '0px' }}
      >
        {children}
      </div>
    </div>
  );
};
